const profileConstants = {
  VIEW_MEMBER_PROFILE: "VIEW_MEMBER_PROFILE",
  LIKE_MEMBER_PROFILE: "LIKE_MEMBER_PROFILE",
  EXPRESS_INTEREST: "EXPRESS_INTEREST",
  SHORTLIST: "SHORTLIST",
  SAVE: "SAVE",
  ADD_TO_FAVORITE: "ADD_TO_FAVORITE",
  CHANGE_PROFILE_LIKED_STATUS: "CHANGE_PROFILE_LIKED_STATUS",
  CHANGE_PROFILE_INTEREST_STATUS: "CHANGE_PROFILE_INTEREST_STATUS",
  CHANGE_PROFILE_SHORTLISTED_STATUS: "CHANGE_PROFILE_SHORTLISTED_STATUS",
  CHANGE_PROFILE_SAVED_STATUS: "CHANGE_PROFILE_SAVED_STATUS",
  CHANGE_PROFILE_ADDED_TO_FAVORITE: "CHANGE_PROFILE_ADDED_TO_FAVORITE",
  CHANGE_REQUEST_PENDING_FOR_CONNECT: "CHANGE_REQUEST_PENDING_FOR_CONNECT",
  CHANGE_REQUESTED_TO_CONNECT: "CHANGE_REQUESTED_TO_CONNECT",
  CHANGE_CONNECTED: "CHANGE_CONNECT",
  UNLIKE_MEMBER_PROFILE: "UNLIKE_MEMBER_PROFILE",
  CANCEL_EXPRESS_INTEREST: "CANCEL_EXPRESS_INTEREST",
  REMOVE_FROM_SHORTLIST: "REMOVE_FROM_SHORTLIST",
  REMOVE_FROM_SAVED: "REMOVE_FROM_SAVED",
  REMOVE_FROM_ADD_TO_FAVORITE: "REMOVE_FROM_ADD_TO_FAVORITE",
  GET_MEMBERS_PARTNER_PREFERENCE: "GET_MEMBERS_PARTNER_PREFERENCE",
  CLEAR_MEMBERS_PARTNER_PREFERENCE: "CLEAR_MEMBERS_PARTNER_PREFERENCE",
  CONNECT_MEMBER: "CONNECT_MEMBER",
  APPROVE_CONNECT_TO_MEMBER: "APPROVE_CONNECT_TO_MEMBER",
  DISCONNECT_WITH_MEMBER: "DISCONNECT_WITH_MEMBER",
  CONNECT_PENDING_STATUS: "PENDING",
  CONNECT_APPROVED_STATUS: "APPROVED",
  GET_MEMBER_PRIVACY: "GET_MEMBER_PRIVACY",
  GET_MEMBER_TOP_IMAGES: "GET_MEMBER_TOP_IMAGES",
  CLEAR_MEMBER_TOP_IMAGES: "CLEAR_MEMBER_TOP_IMAGES",
  CLEAR_MEMBER_PRIVACY: "CLEAR_MEMBER_PRIVACY",
  CLEAR_MEMBER_PROFILE: "CLEAR_MEMBER_PROFILE",
  GET_MEMBER_ALL_IMAGES: "GET_MEMBER_ALL_IMAGES",
  CLEAR_MEMBER_ALL_IMAGES: "CLEAR_MEMBER_ALL_IMAGES",
  GET_MEMBER_MOBILE_NUMBER: "GET_MEMBER_MOBILE_NUMBER",
  CLEAR_MEMBER_MOBILE_NUMBER: "CLEAR_MEMBER_MOBILE_NUMBER"
};
export default profileConstants;



// WEBPACK FOOTER //
// ./src/_constants/profileConstants.js